import SignalsList from "@/components/Signals/SignalsList";
import { PageWrapper } from "@/components/UnifiedRegistry/BreadcrumbsPageWrapper";

const Signals = () => (
  <PageWrapper className="flex h-full min-h-0 flex-col overflow-hidden px-6 pb-4 pt-8">
    <SignalsList />
  </PageWrapper>
);

export default Signals;
